<template>
  <div style="width: 100%;height: 100%">
    <el-form :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="95px" class="demo-ruleForm">
      <el-row>
        <el-col :span="24">
          <el-form-item label="章节名称" prop="name">
            <el-input v-model="addEditForm.name" placeholder="请输入章节名称"></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="author">
            <!--                      <div>{{selectChapter.sortNumber}}</div>-->
            <el-input v-model="addEditForm.sortNumber" placeholder="请输入排序"></el-input>
          </el-form-item>
          <el-form-item label="章节介绍" prop="author">
            <el-input type="textarea" rows="4" placeholder="请输入章节介绍"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="margin: 20px 30px 0">
      <el-row style="text-align: center">
        <el-col :span="12"><el-button type="danger" size="medium" @click="closeOpen()">取消</el-button></el-col>
        <el-col :span="12"><el-button type="success" size="medium" @click="submitAddEdit('addEditForm')">确定</el-button></el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {addBookChapter, editBookChapter} from '../../api/bookChapter'

export default {
  name: 'addEditChapter',
  model: {
    prop: 'addEditChapterShow',
    event: 'change'
  },
  props: {
    chapterObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      addEditForm: {
        name: '',
        sortNumber: 0
      },
      addEditRules: {
        name: [
          { required: true, message: '请输入章节名称', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.getFormData()
  },
  methods: {
    getFormData () {
      if (!this.chapterObj.isAdd) {
        this.addEditForm.name = this.chapterObj.row.name
        this.addEditForm.sortNumber = this.chapterObj.row.sortNumber
      } else {
        this.addEditForm.name = ''
        this.addEditForm.sortNumber = ''
      }
    },
    closeOpen () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.chapterObj.isAdd) {
            this.sendAddChapter()
          } else {
            this.sendEditChapter()
          }
        } else {
          return false
        }
      })
    },
    sendAddChapter () {
      let body = {
        bookId: this.chapterObj.type === 0 ? this.chapterObj.row.id : this.chapterObj.row.bookId,
        name: this.addEditForm.name,
        parentId: this.chapterObj.type === 0 ? 0 : this.chapterObj.row.id,
        sortNumber: parseInt(this.addEditForm.sortNumber)
      }
      addBookChapter(body).then(res => {
        this.$message({
          message: '成功添加书本章节',
          type: 'success'
        })
        this.$emit('getFatherChapter')
        this.$emit('change', false)
      })
    },
    sendEditChapter () {
      let body = {
        id: this.chapterObj.row.id,
        bookId: this.chapterObj.row.bookId,
        name: this.addEditForm.name,
        parentId: this.chapterObj.row.parentId,
        sortNumber: parseInt(this.addEditForm.sortNumber)
      }
      editBookChapter(body).then(res => {
        this.$message({
          message: '成功更新章节',
          type: 'success'
        })
        this.$emit('getFatherChapter')
        this.$emit('change', false)
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/materialManagement/addEditChapter.vue